@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-539_369_122)
internal val Res.string.rh_unit_review_manager: StringResource by lazy {
      StringResource("string:rh_unit_review_manager", "rh_unit_review_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79396, 50),
      ))
    }

@delegate:ResourceContentHash(331_728_884)
internal val Res.string.rh_unit_review_message: StringResource by lazy {
      StringResource("string:rh_unit_review_message", "rh_unit_review_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79447, 202),
      ))
    }

@delegate:ResourceContentHash(-643_063_855)
internal val Res.string.rh_unit_review_no_units: StringResource by lazy {
      StringResource("string:rh_unit_review_no_units", "rh_unit_review_no_units", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79650, 311),
      ))
    }

@delegate:ResourceContentHash(880_301_370)
internal val Res.string.rh_unit_review_none: StringResource by lazy {
      StringResource("string:rh_unit_review_none", "rh_unit_review_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79962, 43),
      ))
    }

@delegate:ResourceContentHash(-1_566_421_878)
internal val Res.string.rh_unit_review_pending: StringResource by lazy {
      StringResource("string:rh_unit_review_pending", "rh_unit_review_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80006, 82),
      ))
    }

@delegate:ResourceContentHash(1_758_653_228)
internal val Res.string.rh_unit_review_search: StringResource by lazy {
      StringResource("string:rh_unit_review_search", "rh_unit_review_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80089, 49),
      ))
    }

@delegate:ResourceContentHash(570_099_837)
internal val Res.string.rh_unit_review_status_confirmed: StringResource by lazy {
      StringResource("string:rh_unit_review_status_confirmed", "rh_unit_review_status_confirmed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80139, 59),
      ))
    }

@delegate:ResourceContentHash(1_841_274_696)
internal val Res.string.rh_unit_review_status_exact: StringResource by lazy {
      StringResource("string:rh_unit_review_status_exact", "rh_unit_review_status_exact", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80199, 51),
      ))
    }

@delegate:ResourceContentHash(1_685_372_181)
internal val Res.string.rh_unit_review_status_manual: StringResource by lazy {
      StringResource("string:rh_unit_review_status_manual", "rh_unit_review_status_manual", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80251, 48),
      ))
    }

@delegate:ResourceContentHash(880_301_370)
internal val Res.string.rh_unit_review_status_missing: StringResource by lazy {
      StringResource("string:rh_unit_review_status_missing", "rh_unit_review_status_missing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80300, 53),
      ))
    }

@delegate:ResourceContentHash(971_158_013)
internal val Res.string.rh_unit_review_status_suggested: StringResource by lazy {
      StringResource("string:rh_unit_review_status_suggested", "rh_unit_review_status_suggested", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80354, 51),
      ))
    }

@delegate:ResourceContentHash(-1_895_215_146)
internal val Res.string.rh_unit_review_title: StringResource by lazy {
      StringResource("string:rh_unit_review_title", "rh_unit_review_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80406, 52),
      ))
    }

@delegate:ResourceContentHash(-1_651_349_331)
internal val Res.string.rh_units_title: StringResource by lazy {
      StringResource("string:rh_units_title", "rh_units_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80459, 54),
      ))
    }

@delegate:ResourceContentHash(-1_372_878_261)
internal val Res.string.rh_vacancies_by_function: StringResource by lazy {
      StringResource("string:rh_vacancies_by_function", "rh_vacancies_by_function", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80514, 56),
      ))
    }

@delegate:ResourceContentHash(-1_778_659_377)
internal val Res.string.rh_vacancies_by_status: StringResource by lazy {
      StringResource("string:rh_vacancies_by_status", "rh_vacancies_by_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80571, 54),
      ))
    }

@delegate:ResourceContentHash(-588_332_169)
internal val Res.string.rh_vacancies_by_unit: StringResource by lazy {
      StringResource("string:rh_vacancies_by_unit", "rh_vacancies_by_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80626, 48),
      ))
    }

@delegate:ResourceContentHash(-1_635_729_163)
internal val Res.string.rh_vacancies_empty: StringResource by lazy {
      StringResource("string:rh_vacancies_empty", "rh_vacancies_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80675, 66),
      ))
    }

@delegate:ResourceContentHash(1_318_128_553)
internal val Res.string.rh_vacancies_hint: StringResource by lazy {
      StringResource("string:rh_vacancies_hint", "rh_vacancies_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80742, 121),
      ))
    }

@delegate:ResourceContentHash(1_260_508_264)
internal val Res.string.rh_vacancies_list: StringResource by lazy {
      StringResource("string:rh_vacancies_list", "rh_vacancies_list", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80864, 57),
      ))
    }

@delegate:ResourceContentHash(-241_816_200)
internal val Res.string.rh_vacancies_top_function: StringResource by lazy {
      StringResource("string:rh_vacancies_top_function", "rh_vacancies_top_function", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80922, 69),
      ))
    }

@delegate:ResourceContentHash(663_008_785)
internal val Res.string.rh_vacancies_top_unit: StringResource by lazy {
      StringResource("string:rh_vacancies_top_unit", "rh_vacancies_top_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80992, 61),
      ))
    }

@delegate:ResourceContentHash(-372_829_395)
internal val Res.string.rh_vacancies_total: StringResource by lazy {
      StringResource("string:rh_vacancies_total", "rh_vacancies_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81054, 46),
      ))
    }

@delegate:ResourceContentHash(-1_972_891_150)
internal val Res.string.rmp_action_details: StringResource by lazy {
      StringResource("string:rmp_action_details", "rmp_action_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81101, 38),
      ))
    }

@delegate:ResourceContentHash(1_535_651_542)
internal val Res.string.rmp_admin_apt: StringResource by lazy {
      StringResource("string:rmp_admin_apt", "rmp_admin_apt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81140, 45),
      ))
    }

@delegate:ResourceContentHash(-552_399_256)
internal val Res.string.rmp_admin_hr_status: StringResource by lazy {
      StringResource("string:rmp_admin_hr_status", "rmp_admin_hr_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81186, 59),
      ))
    }

@delegate:ResourceContentHash(-1_049_826_056)
internal val Res.string.rmp_admin_reason: StringResource by lazy {
      StringResource("string:rmp_admin_reason", "rmp_admin_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81246, 56),
      ))
    }

@delegate:ResourceContentHash(1_671_787_194)
internal val Res.string.rmp_admin_reopen: StringResource by lazy {
      StringResource("string:rmp_admin_reopen", "rmp_admin_reopen", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81528, 40),
      ))
    }

@delegate:ResourceContentHash(-56_210_509)
internal val Res.string.rmp_admin_reopen_hint: StringResource by lazy {
      StringResource("string:rmp_admin_reopen_hint", "rmp_admin_reopen_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81303, 169),
      ))
    }

@delegate:ResourceContentHash(1_400_485_256)
internal val Res.string.rmp_admin_reopen_title: StringResource by lazy {
      StringResource("string:rmp_admin_reopen_title", "rmp_admin_reopen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81473, 54),
      ))
    }

@delegate:ResourceContentHash(-2_103_948_557)
internal val Res.string.rmp_admin_replace: StringResource by lazy {
      StringResource("string:rmp_admin_replace", "rmp_admin_replace", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81645, 53),
      ))
    }

@delegate:ResourceContentHash(-328_607_043)
internal val Res.string.rmp_admin_replace_title: StringResource by lazy {
      StringResource("string:rmp_admin_replace_title", "rmp_admin_replace_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81569, 75),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.rmp_admin_save: StringResource by lazy {
      StringResource("string:rmp_admin_save", "rmp_admin_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81699, 30),
      ))
    }

@delegate:ResourceContentHash(-358_974_167)
internal val Res.string.rmp_admin_section: StringResource by lazy {
      StringResource("string:rmp_admin_section", "rmp_admin_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81730, 57),
      ))
    }

@delegate:ResourceContentHash(-1_700_290_175)
internal val Res.string.rmp_approval_approve: StringResource by lazy {
      StringResource("string:rmp_approval_approve", "rmp_approval_approve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81830, 40),
      ))
    }

@delegate:ResourceContentHash(-1_700_589_201)
internal val Res.string.rmp_approval_approved: StringResource by lazy {
      StringResource("string:rmp_approval_approved", "rmp_approval_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81788, 41),
      ))
    }

@delegate:ResourceContentHash(957_289_568)
internal val Res.string.rmp_approval_attachments: StringResource by lazy {
      StringResource("string:rmp_approval_attachments", "rmp_approval_attachments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81871, 40),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.rmp_approval_delete: StringResource by lazy {
      StringResource("string:rmp_approval_delete", "rmp_approval_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82064, 39),
      ))
    }

@delegate:ResourceContentHash(-1_202_733_202)
internal val Res.string.rmp_approval_delete_confirm: StringResource by lazy {
      StringResource("string:rmp_approval_delete_confirm", "rmp_approval_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81912, 151),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.rmp_approval_edit: StringResource by lazy {
      StringResource("string:rmp_approval_edit", "rmp_approval_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82104, 33),
      ))
    }

@delegate:ResourceContentHash(-767_148_684)
internal val Res.string.rmp_approval_fields: StringResource by lazy {
      StringResource("string:rmp_approval_fields", "rmp_approval_fields", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82138, 55),
      ))
    }

@delegate:ResourceContentHash(990_859_755)
internal val Res.string.rmp_approval_history: StringResource by lazy {
      StringResource("string:rmp_approval_history", "rmp_approval_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82194, 64),
      ))
    }

@delegate:ResourceContentHash(1_685_832_421)
internal val Res.string.rmp_approval_note: StringResource by lazy {
      StringResource("string:rmp_approval_note", "rmp_approval_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82259, 125),
      ))
    }

@delegate:ResourceContentHash(-1_329_692_217)
internal val Res.string.rmp_approval_reject: StringResource by lazy {
      StringResource("string:rmp_approval_reject", "rmp_approval_reject", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82427, 39),
      ))
    }

@delegate:ResourceContentHash(-1_329_692_842)
internal val Res.string.rmp_approval_rejected: StringResource by lazy {
      StringResource("string:rmp_approval_rejected", "rmp_approval_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82385, 41),
      ))
    }

@delegate:ResourceContentHash(-2_071_371_871)
internal val Res.string.rmp_approval_title: StringResource by lazy {
      StringResource("string:rmp_approval_title", "rmp_approval_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82467, 38),
      ))
    }

@delegate:ResourceContentHash(1_701_194_309)
internal val Res.string.rmp_attach_documents: StringResource by lazy {
      StringResource("string:rmp_attach_documents", "rmp_attach_documents", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82506, 52),
      ))
    }

@delegate:ResourceContentHash(-849_078_174)
internal val Res.string.rmp_attachment_not_copied: StringResource by lazy {
      StringResource("string:rmp_attachment_not_copied", "rmp_attachment_not_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82559, 77),
      ))
    }

@delegate:ResourceContentHash(1_147_682_803)
internal val Res.string.rmp_card_finished: StringResource by lazy {
      StringResource("string:rmp_card_finished", "rmp_card_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82637, 61),
      ))
    }

@delegate:ResourceContentHash(-730_499_834)
internal val Res.string.rmp_card_in_progress: StringResource by lazy {
      StringResource("string:rmp_card_in_progress", "rmp_card_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82699, 64),
      ))
    }

@delegate:ResourceContentHash(2_120_664_837)
internal val Res.string.rmp_card_my_pending: StringResource by lazy {
      StringResource("string:rmp_card_my_pending", "rmp_card_my_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82764, 51),
      ))
    }

@delegate:ResourceContentHash(138_827_213)
internal val Res.string.rmp_card_total: StringResource by lazy {
      StringResource("string:rmp_card_total", "rmp_card_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82816, 54),
      ))
    }

@delegate:ResourceContentHash(1_700_239_956)
internal val Res.string.rmp_checklist_aso: StringResource by lazy {
      StringResource("string:rmp_checklist_aso", "rmp_checklist_aso", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82871, 37),
      ))
    }

@delegate:ResourceContentHash(-1_039_041_028)
internal val Res.string.rmp_checklist_complete: StringResource by lazy {
      StringResource("string:rmp_checklist_complete", "rmp_checklist_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82909, 42),
      ))
    }

@delegate:ResourceContentHash(-1_496_454_400)
internal val Res.string.rmp_checklist_fill: StringResource by lazy {
      StringResource("string:rmp_checklist_fill", "rmp_checklist_fill", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83020, 54),
      ))
    }

@delegate:ResourceContentHash(1_832_392_311)
internal val Res.string.rmp_checklist_filled_by: StringResource by lazy {
      StringResource("string:rmp_checklist_filled_by", "rmp_checklist_filled_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82952, 67),
      ))
    }

@delegate:ResourceContentHash(-1_851_921_318)
internal val Res.string.rmp_checklist_incomplete: StringResource by lazy {
      StringResource("string:rmp_checklist_incomplete", "rmp_checklist_incomplete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83075, 192),
      ))
    }

@delegate:ResourceContentHash(441_731_364)
internal val Res.string.rmp_checklist_observation: StringResource by lazy {
      StringResource("string:rmp_checklist_observation", "rmp_checklist_observation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83268, 49),
      ))
    }

@delegate:ResourceContentHash(-175_622_154)
internal val Res.string.rmp_checklist_save: StringResource by lazy {
      StringResource("string:rmp_checklist_save", "rmp_checklist_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83318, 50),
      ))
    }

@delegate:ResourceContentHash(-592_774_334)
internal val Res.string.rmp_checklist_section: StringResource by lazy {
      StringResource("string:rmp_checklist_section", "rmp_checklist_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83369, 65),
      ))
    }

@delegate:ResourceContentHash(1_886_039_488)
internal val Res.string.rmp_checklist_signature: StringResource by lazy {
      StringResource("string:rmp_checklist_signature", "rmp_checklist_signature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83435, 75),
      ))
    }

@delegate:ResourceContentHash(672_657_974)
internal val Res.string.rmp_checklist_title: StringResource by lazy {
      StringResource("string:rmp_checklist_title", "rmp_checklist_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83511, 79),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.rmp_col_actions: StringResource by lazy {
      StringResource("string:rmp_col_actions", "rmp_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83591, 35),
      ))
    }

@delegate:ResourceContentHash(1_040_542_822)
internal val Res.string.rmp_col_created_at: StringResource by lazy {
      StringResource("string:rmp_col_created_at", "rmp_col_created_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83627, 38),
      ))
    }

@delegate:ResourceContentHash(2_556_910)
internal val Res.string.rmp_col_id: StringResource by lazy {
      StringResource("string:rmp_col_id", "rmp_col_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83666, 22),
      ))
    }

@delegate:ResourceContentHash(1_875_060_300)
internal val Res.string.rmp_col_requester: StringResource by lazy {
      StringResource("string:rmp_col_requester", "rmp_col_requester", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83689, 41),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.rmp_col_status: StringResource by lazy {
      StringResource("string:rmp_col_status", "rmp_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83731, 30),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.rmp_col_type: StringResource by lazy {
      StringResource("string:rmp_col_type", "rmp_col_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83762, 28),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.rmp_col_unit: StringResource by lazy {
      StringResource("string:rmp_col_unit", "rmp_col_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83791, 32),
      ))
    }

@delegate:ResourceContentHash(25_123_129)
internal val Res.string.rmp_col_updated_at: StringResource by lazy {
      StringResource("string:rmp_col_updated_at", "rmp_col_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83824, 46),
      ))
    }

@delegate:ResourceContentHash(-1_041_933_943)
internal val Res.string.rmp_col_waiting: StringResource by lazy {
      StringResource("string:rmp_col_waiting", "rmp_col_waiting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83871, 47),
      ))
    }

@delegate:ResourceContentHash(592_630_944)
internal val Res.string.rmp_decision_approve_title: StringResource by lazy {
      StringResource("string:rmp_decision_approve_title", "rmp_decision_approve_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83919, 58),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.rmp_decision_cancel: StringResource by lazy {
      StringResource("string:rmp_decision_cancel", "rmp_decision_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83978, 39),
      ))
    }

@delegate:ResourceContentHash(-1_746_436_078)
internal val Res.string.rmp_decision_reject_title: StringResource by lazy {
      StringResource("string:rmp_decision_reject_title", "rmp_decision_reject_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84018, 57),
      ))
    }

@delegate:ResourceContentHash(1_185_998_799)
internal val Res.string.rmp_decision_summary: StringResource by lazy {
      StringResource("string:rmp_decision_summary", "rmp_decision_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84076, 64),
      ))
    }

@delegate:ResourceContentHash(-1_711_274_744)
internal val Res.string.rmp_details_email: StringResource by lazy {
      StringResource("string:rmp_details_email", "rmp_details_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84141, 53),
      ))
    }

@delegate:ResourceContentHash(810_059_185)
internal val Res.string.rmp_details_last_action: StringResource by lazy {
      StringResource("string:rmp_details_last_action", "rmp_details_last_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84195, 51),
      ))
    }

@delegate:ResourceContentHash(-1_470_030_933)
internal val Res.string.rmp_details_title: StringResource by lazy {
      StringResource("string:rmp_details_title", "rmp_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84247, 57),
      ))
    }

@delegate:ResourceContentHash(857_113_066)
internal val Res.string.rmp_document: StringResource by lazy {
      StringResource("string:rmp_document", "rmp_document", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84305, 60),
      ))
    }

@delegate:ResourceContentHash(555_430_058)
internal val Res.string.rmp_edit_save: StringResource by lazy {
      StringResource("string:rmp_edit_save", "rmp_edit_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84366, 49),
      ))
    }

@delegate:ResourceContentHash(-1_910_367_434)
internal val Res.string.rmp_edit_subtitle: StringResource by lazy {
      StringResource("string:rmp_edit_subtitle", "rmp_edit_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84416, 185),
      ))
    }

@delegate:ResourceContentHash(1_551_756_417)
internal val Res.string.rmp_edit_title: StringResource by lazy {
      StringResource("string:rmp_edit_title", "rmp_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84602, 42),
      ))
    }

@delegate:ResourceContentHash(683_505_719)
internal val Res.string.rmp_empty: StringResource by lazy {
      StringResource("string:rmp_empty", "rmp_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84645, 57),
      ))
    }

@delegate:ResourceContentHash(-2_036_852_645)
internal val Res.string.rmp_evaluation_actions: StringResource by lazy {
      StringResource("string:rmp_evaluation_actions", "rmp_evaluation_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84703, 66),
      ))
    }

@delegate:ResourceContentHash(2_109_338_713)
internal val Res.string.rmp_evaluation_admission: StringResource by lazy {
      StringResource("string:rmp_evaluation_admission", "rmp_evaluation_admission", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84770, 56),
      ))
    }

@delegate:ResourceContentHash(-1_480_351_479)
internal val Res.string.rmp_evaluation_average: StringResource by lazy {
      StringResource("string:rmp_evaluation_average", "rmp_evaluation_average", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84827, 54),
      ))
    }

@delegate:ResourceContentHash(-1_440_146_562)
internal val Res.string.rmp_evaluation_done: StringResource by lazy {
      StringResource("string:rmp_evaluation_done", "rmp_evaluation_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84882, 91),
      ))
    }

@delegate:ResourceContentHash(-1_767_908_288)
internal val Res.string.rmp_evaluation_fill: StringResource by lazy {
      StringResource("string:rmp_evaluation_fill", "rmp_evaluation_fill", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84974, 55),
      ))
    }

@delegate:ResourceContentHash(716_352_943)
internal val Res.string.rmp_evaluation_name: StringResource by lazy {
      StringResource("string:rmp_evaluation_name", "rmp_evaluation_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85030, 55),
      ))
    }

@delegate:ResourceContentHash(606_305_263)
internal val Res.string.rmp_evaluation_opinion: StringResource by lazy {
      StringResource("string:rmp_evaluation_opinion", "rmp_evaluation_opinion", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85086, 62),
      ))
    }

@delegate:ResourceContentHash(-1_870_125_806)
internal val Res.string.rmp_evaluation_pending: StringResource by lazy {
      StringResource("string:rmp_evaluation_pending", "rmp_evaluation_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85149, 162),
      ))
    }

@delegate:ResourceContentHash(-2_141_843_734)
internal val Res.string.rmp_evaluation_period: StringResource by lazy {
      StringResource("string:rmp_evaluation_period", "rmp_evaluation_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85312, 89),
      ))
    }

@delegate:ResourceContentHash(-1_317_222_191)
internal val Res.string.rmp_evaluation_role: StringResource by lazy {
      StringResource("string:rmp_evaluation_role", "rmp_evaluation_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85402, 35),
      ))
    }

@delegate:ResourceContentHash(-447_076_042)
internal val Res.string.rmp_evaluation_save: StringResource by lazy {
      StringResource("string:rmp_evaluation_save", "rmp_evaluation_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85438, 51),
      ))
    }

@delegate:ResourceContentHash(-873_646_624)
internal val Res.string.rmp_evaluation_scores_hint: StringResource by lazy {
      StringResource("string:rmp_evaluation_scores_hint", "rmp_evaluation_scores_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85490, 94),
      ))
    }

@delegate:ResourceContentHash(-1_263_409_276)
internal val Res.string.rmp_evaluation_section: StringResource by lazy {
      StringResource("string:rmp_evaluation_section", "rmp_evaluation_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85585, 66),
      ))
    }

@delegate:ResourceContentHash(1_749_941_052)
internal val Res.string.rmp_evaluation_sector: StringResource by lazy {
      StringResource("string:rmp_evaluation_sector", "rmp_evaluation_sector", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85652, 37),
      ))
    }

@delegate:ResourceContentHash(2_078_458_300)
internal val Res.string.rmp_evaluation_skills: StringResource by lazy {
      StringResource("string:rmp_evaluation_skills", "rmp_evaluation_skills", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85690, 73),
      ))
    }

@delegate:ResourceContentHash(1_193_178_983)
internal val Res.string.rmp_evaluation_title: StringResource by lazy {
      StringResource("string:rmp_evaluation_title", "rmp_evaluation_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85764, 80),
      ))
    }

@delegate:ResourceContentHash(1_547_658_012)
internal val Res.string.rmp_export: StringResource by lazy {
      StringResource("string:rmp_export", "rmp_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85887, 38),
      ))
    }

@delegate:ResourceContentHash(2_021_458_067)
internal val Res.string.rmp_exporting: StringResource by lazy {
      StringResource("string:rmp_exporting", "rmp_exporting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85845, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString11Resources(map: MutableMap<String, StringResource>) {
  map.put("rh_unit_review_manager", Res.string.rh_unit_review_manager)
  map.put("rh_unit_review_message", Res.string.rh_unit_review_message)
  map.put("rh_unit_review_no_units", Res.string.rh_unit_review_no_units)
  map.put("rh_unit_review_none", Res.string.rh_unit_review_none)
  map.put("rh_unit_review_pending", Res.string.rh_unit_review_pending)
  map.put("rh_unit_review_search", Res.string.rh_unit_review_search)
  map.put("rh_unit_review_status_confirmed", Res.string.rh_unit_review_status_confirmed)
  map.put("rh_unit_review_status_exact", Res.string.rh_unit_review_status_exact)
  map.put("rh_unit_review_status_manual", Res.string.rh_unit_review_status_manual)
  map.put("rh_unit_review_status_missing", Res.string.rh_unit_review_status_missing)
  map.put("rh_unit_review_status_suggested", Res.string.rh_unit_review_status_suggested)
  map.put("rh_unit_review_title", Res.string.rh_unit_review_title)
  map.put("rh_units_title", Res.string.rh_units_title)
  map.put("rh_vacancies_by_function", Res.string.rh_vacancies_by_function)
  map.put("rh_vacancies_by_status", Res.string.rh_vacancies_by_status)
  map.put("rh_vacancies_by_unit", Res.string.rh_vacancies_by_unit)
  map.put("rh_vacancies_empty", Res.string.rh_vacancies_empty)
  map.put("rh_vacancies_hint", Res.string.rh_vacancies_hint)
  map.put("rh_vacancies_list", Res.string.rh_vacancies_list)
  map.put("rh_vacancies_top_function", Res.string.rh_vacancies_top_function)
  map.put("rh_vacancies_top_unit", Res.string.rh_vacancies_top_unit)
  map.put("rh_vacancies_total", Res.string.rh_vacancies_total)
  map.put("rmp_action_details", Res.string.rmp_action_details)
  map.put("rmp_admin_apt", Res.string.rmp_admin_apt)
  map.put("rmp_admin_hr_status", Res.string.rmp_admin_hr_status)
  map.put("rmp_admin_reason", Res.string.rmp_admin_reason)
  map.put("rmp_admin_reopen", Res.string.rmp_admin_reopen)
  map.put("rmp_admin_reopen_hint", Res.string.rmp_admin_reopen_hint)
  map.put("rmp_admin_reopen_title", Res.string.rmp_admin_reopen_title)
  map.put("rmp_admin_replace", Res.string.rmp_admin_replace)
  map.put("rmp_admin_replace_title", Res.string.rmp_admin_replace_title)
  map.put("rmp_admin_save", Res.string.rmp_admin_save)
  map.put("rmp_admin_section", Res.string.rmp_admin_section)
  map.put("rmp_approval_approve", Res.string.rmp_approval_approve)
  map.put("rmp_approval_approved", Res.string.rmp_approval_approved)
  map.put("rmp_approval_attachments", Res.string.rmp_approval_attachments)
  map.put("rmp_approval_delete", Res.string.rmp_approval_delete)
  map.put("rmp_approval_delete_confirm", Res.string.rmp_approval_delete_confirm)
  map.put("rmp_approval_edit", Res.string.rmp_approval_edit)
  map.put("rmp_approval_fields", Res.string.rmp_approval_fields)
  map.put("rmp_approval_history", Res.string.rmp_approval_history)
  map.put("rmp_approval_note", Res.string.rmp_approval_note)
  map.put("rmp_approval_reject", Res.string.rmp_approval_reject)
  map.put("rmp_approval_rejected", Res.string.rmp_approval_rejected)
  map.put("rmp_approval_title", Res.string.rmp_approval_title)
  map.put("rmp_attach_documents", Res.string.rmp_attach_documents)
  map.put("rmp_attachment_not_copied", Res.string.rmp_attachment_not_copied)
  map.put("rmp_card_finished", Res.string.rmp_card_finished)
  map.put("rmp_card_in_progress", Res.string.rmp_card_in_progress)
  map.put("rmp_card_my_pending", Res.string.rmp_card_my_pending)
  map.put("rmp_card_total", Res.string.rmp_card_total)
  map.put("rmp_checklist_aso", Res.string.rmp_checklist_aso)
  map.put("rmp_checklist_complete", Res.string.rmp_checklist_complete)
  map.put("rmp_checklist_fill", Res.string.rmp_checklist_fill)
  map.put("rmp_checklist_filled_by", Res.string.rmp_checklist_filled_by)
  map.put("rmp_checklist_incomplete", Res.string.rmp_checklist_incomplete)
  map.put("rmp_checklist_observation", Res.string.rmp_checklist_observation)
  map.put("rmp_checklist_save", Res.string.rmp_checklist_save)
  map.put("rmp_checklist_section", Res.string.rmp_checklist_section)
  map.put("rmp_checklist_signature", Res.string.rmp_checklist_signature)
  map.put("rmp_checklist_title", Res.string.rmp_checklist_title)
  map.put("rmp_col_actions", Res.string.rmp_col_actions)
  map.put("rmp_col_created_at", Res.string.rmp_col_created_at)
  map.put("rmp_col_id", Res.string.rmp_col_id)
  map.put("rmp_col_requester", Res.string.rmp_col_requester)
  map.put("rmp_col_status", Res.string.rmp_col_status)
  map.put("rmp_col_type", Res.string.rmp_col_type)
  map.put("rmp_col_unit", Res.string.rmp_col_unit)
  map.put("rmp_col_updated_at", Res.string.rmp_col_updated_at)
  map.put("rmp_col_waiting", Res.string.rmp_col_waiting)
  map.put("rmp_decision_approve_title", Res.string.rmp_decision_approve_title)
  map.put("rmp_decision_cancel", Res.string.rmp_decision_cancel)
  map.put("rmp_decision_reject_title", Res.string.rmp_decision_reject_title)
  map.put("rmp_decision_summary", Res.string.rmp_decision_summary)
  map.put("rmp_details_email", Res.string.rmp_details_email)
  map.put("rmp_details_last_action", Res.string.rmp_details_last_action)
  map.put("rmp_details_title", Res.string.rmp_details_title)
  map.put("rmp_document", Res.string.rmp_document)
  map.put("rmp_edit_save", Res.string.rmp_edit_save)
  map.put("rmp_edit_subtitle", Res.string.rmp_edit_subtitle)
  map.put("rmp_edit_title", Res.string.rmp_edit_title)
  map.put("rmp_empty", Res.string.rmp_empty)
  map.put("rmp_evaluation_actions", Res.string.rmp_evaluation_actions)
  map.put("rmp_evaluation_admission", Res.string.rmp_evaluation_admission)
  map.put("rmp_evaluation_average", Res.string.rmp_evaluation_average)
  map.put("rmp_evaluation_done", Res.string.rmp_evaluation_done)
  map.put("rmp_evaluation_fill", Res.string.rmp_evaluation_fill)
  map.put("rmp_evaluation_name", Res.string.rmp_evaluation_name)
  map.put("rmp_evaluation_opinion", Res.string.rmp_evaluation_opinion)
  map.put("rmp_evaluation_pending", Res.string.rmp_evaluation_pending)
  map.put("rmp_evaluation_period", Res.string.rmp_evaluation_period)
  map.put("rmp_evaluation_role", Res.string.rmp_evaluation_role)
  map.put("rmp_evaluation_save", Res.string.rmp_evaluation_save)
  map.put("rmp_evaluation_scores_hint", Res.string.rmp_evaluation_scores_hint)
  map.put("rmp_evaluation_section", Res.string.rmp_evaluation_section)
  map.put("rmp_evaluation_sector", Res.string.rmp_evaluation_sector)
  map.put("rmp_evaluation_skills", Res.string.rmp_evaluation_skills)
  map.put("rmp_evaluation_title", Res.string.rmp_evaluation_title)
  map.put("rmp_export", Res.string.rmp_export)
  map.put("rmp_exporting", Res.string.rmp_exporting)
}
